<template>
  <div v-if="floatBannerList.length > 0">
    <a href="#" v-for="(bannerInfo, index) in floatBannerList" class="bottom-banner" @click.prevent="moveUrl(bannerInfo)" :style="{ background: '-webkit-linear-gradient(99deg, '+ startColor(bannerInfo) +', '+ endColor(bannerInfo) +' 100%)', background: '-moz-linear-gradient(99deg, '+ startColor(bannerInfo) +', '+ endColor(bannerInfo) +' 100%)', background: '-o-linear-gradient(99deg, '+ startColor(bannerInfo) +', '+ endColor(bannerInfo) +' 100%)', background: 'linear-gradient(99deg, '+ startColor(bannerInfo) +', '+ endColor(bannerInfo) +' 100%)'}" :key="index">
      <img :src="bannerIcon(bannerInfo)" :alt="bannerIconAlt(bannerInfo)">
      <span>{{ title(bannerInfo) }}</span>
    </a>
  </div>
</template>
<script>
import { get, defaultTo } from 'lodash'
import { getEventListByType } from '@/common/util/event.util'
import { bannerLink } from '@/common/util/common'
import { EventService } from '@/common/api/api.service'
import EventModelClass from '@/common/model/EventModelClass'
import { resizeThumbnail } from '@/common/image.filter'
export default {
  name: 'TemplateFloatingBanner',
  props: {
    sectionInfo: {
      type: Object
    }
  },
  data () {
    return {
      floatBannerList: []
    }
  },
  methods: {
    bannerIcon (bannerInfo) {
      const icon = defaultTo(get(bannerInfo, 'icon', ''), '')
      return resizeThumbnail(icon, { width: 0, height: 0, option: '20', quality: 80 })
    },
    bannerIconAlt (bannerInfo) {
      return defaultTo(get(bannerInfo, 'icon_alt', ''), '')
    },
    startColor (bannerInfo) {
      return defaultTo(get(bannerInfo, 'startcolor', ''), '')
    },
    endColor (bannerInfo) {
      return defaultTo(get(bannerInfo, 'endcolor', ''), '')
    },
    title (bannerInfo) {
      return defaultTo(get(bannerInfo, 'title_list.0.text', ''), '')
    },
    moveUrl (bannerInfo) {
      const { onNavigationEvent } = getEventListByType(defaultTo(get(bannerInfo, 'event_list', []), []))
      bannerLink(defaultTo(get(onNavigationEvent, 'url', ''), ''))
    }
  },
  created () {
    EventService.requestEventData(new EventModelClass(this.sectionInfo.contentEvent)).then(({ data }) => {
      this.floatBannerList = defaultTo(get(data, 'band.celllist', []), [])
    })
  }
}
</script>
